<template>
  <el-card>
    <div>
      <el-button icon="el-icon-arrow-left" @click="returnlist()">列表</el-button>
      <!-- 员工管理-添加编辑 -->
      <el-form
       style="margin-top:20px;"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="truename">
          <el-input v-model="ruleForm.truename"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleid">
          <el-select placeholder="请选择角色" v-model="ruleForm.roleid">
            <el-option
              v-for="item in rolelist"
              :value="item.roleid"
              :key="item.roleid"
              :label="item.rolename"
            >{{item.rolename}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机" prop="mobile">
          <el-input v-model="ruleForm.mobile" oninput = "value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="ruleForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex">
            <el-radio value="M" label="M">男</el-radio>
            <el-radio value="F" label="F">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-input v-model="ruleForm.position"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="intro">
          <el-input type="textarea" v-model="ruleForm.intro"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import qs from "qs";
export default {
  data() {
    var validPhone=(rule, value,callback)=>{
      if (!value){
        callback(new Error('请输入手机号码'))
      }else  if (!this.isvalidPhone(value)){
        callback(new Error('请输入正确的11位手机号码'))
      }else {
        callback()
      }
    }
    var validMail=(rule, value,callback)=>{
      if (!value){
        callback(new Error('请输入电子邮箱'))
      }else  if (!this.isvalidMaile(value)){
        callback(new Error('请输入正确的邮箱'))
      }else {
        callback()
      }
    }


    return {
      ruleForm: {},
      rolelist:[],
      rules: {
        username:[{
          required: true,
          message: "此项为必填项",
          trigger: "blur"
        },
          // { min: 2, max: 6, message: '长度在2-6字之间', trigger: 'blur' }
        ],
        truename:[{
          required: true,
          message: "此项为必填项",
          trigger: "blur"
        },
          { min: 2, max: 6, message: '长度在2-6字之间', trigger: 'blur' }
        ],
        name: [
          {
            required: true,
            message: "此项为必填项",
            trigger: "blur"
          }
        ],
        mobile:[{ required: true, trigger: 'blur', validator: validPhone,message: "请输入正确的手机号" }
          ],
        password:[
          { min: 6, max: 16, message: '长度为6-16位', trigger: 'blur' }
        ],
        email:[{
          required: true,
          validator: validMail,
          message:"请输入正确的邮箱",
          trigger:"blur"
        }],
        roleid:[{required: true,message:"请选择角色",
          trigger:"blur"}]

      }
    };
  },
  methods: {
    isvalidPhone:function(str) {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      return reg.test(str)
    },
    isvalidMaile:function(str){
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return reg.test(str);
    },
    submitForm: async function(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            `v1/busUser/saveOrUpdateUser`,
            this.ruleForm
          );
          var {code, message, data} = res.data;
          if (code == 0) {
            this.$router.push(`/stafflist`);
            this.$message.success("添加/编辑成功");
          } else {
            this.$message.error(message);
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getinfo: async function() {
      var id = this.$route.query.id;
      var res = await this.$http.get(`/v1/busUser/getById?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.ruleForm = data;
      }
    },
    returnlist: function() {
      this.$router.push(`/stafflist`);
    },
    getrolelist:async function () {
      var res =await this.$http.get(
        `/v1/busUser/selectRoleAll`
      );
      var {data,code,message} = res.data;
      if(code==0){
        this.rolelist=data;
      }
    }
  },
  mounted() {
    this.getinfo();
    this.getrolelist();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/staff-mg/staffadd.vue